import { useEffect, ReactNode } from "react";
import { useRouter } from "next/router";

import useAuth from "../lib/useAuth";

export default function UnAuthContent({ children, noRedirect }: { children: ReactNode, noRedirect?: boolean }) {
    const { loggedIn } = useAuth();
    const router = useRouter();

    // Navigate authenticated users to Members page.
    useEffect(() => {
        if (loggedIn && !noRedirect) {
            router.push('/');
        }
    }, [loggedIn, router]);

    if (!loggedIn) {
        return <>{children}</>;
    }

    return <p></p>;
}